<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Yearly Summary Listing</v-card-title>
      <v-row class="px-4">
        <v-col cols="10">
          <v-row class="px-4">
            <v-col>
              <v-autocomplete
                v-model="year"
                v-validate="'required'"
                label="Year"
                :loading="loading"
                :items="years"
                item-value="id"
                :error-messages="errors.collect('year')"
                data-vv-name="year"
                data-vv-as="year"
              />
            </v-col>

            <v-col>
              <v-autocomplete
                v-model="company"
                v-validate="'required'"
                :items="companies"
                :loading="loading"
                label="Companies"
                item-text="name"
                item-value="id"
                multiple
                chips
                small-chips
                deletable-chips
                :error-messages="errors.collect('company')"
                data-vv-name="company"  
                data-vv-as="company"
              />
            </v-col>

            <v-col>
              <v-autocomplete
                v-model="categoryColumns"
                v-validate="'required'"
                label="Category"
                :error-messages="errors.collect('categoryColumns')"
                data-vv-name="categoryColumns"
                data-vv-as="categoryColumns"
                :loading="loading"
                :items="categories"
                clearable
                multiple
                hide-selected 
                chips
                small-chips
                deletable-chips
                item-text="name"
                item-value="name"
              />
            </v-col>          
          </v-row>

          <v-row class="px-4">
            <v-col>
              <v-autocomplete
                v-model="selectedDynamicColumns"
                label="Extra Columns"
                item-text="name"
                item-value="id"
                :loading="loading"
                :items="dynamicColumns"
                clearable
                multiple
                hide-selected 
                chips
                small-chips
                deletable-chips
                :error-messages="errors.collect('selectedDynamicColumns')"
                data-vv-name="selectedDynamicColumns"  
                data-vv-as="extra columns"
              />
            </v-col>  
            <v-col />
            <v-col />
          </v-row>
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="progressing" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>

          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                :loading="progressing"
                color="primary"
                @click="generate"
              >
                generate
              </v-btn>
            </v-col>
          </v-row> 
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        progressing: false,
        year: null,
        years: [],
        progressbar: 0,
        categoryColumns: null,
        categories: [
          { name: 'ALLOWANCES' },          
          { name: 'BASIC' },
          { name: 'BONUS' },
          { name: 'COMMISSION' },
          { name: 'DEDUCTIONS' },          
          { name: 'DIRECTOR FEE' }, 
          { name: 'EIS' },
          { name: 'EPF' },
          { name: 'OT' }, 
          { name: 'PCB' },
          { name: 'SOCSO' }, 
        ],
        company: null,
        companies: [],
        dynamicColumns: [
          { id: 'BASED LOCATION (STATE)', name: 'BASED LOCATION (STATE)' },
          { id: 'COST CENTER', name: 'COST CENTER' },
          { id: 'DEPARTMENT', name: 'DEPARTMENT' },
          { id: 'START DATE', name: 'START DATE' },
          { id: 'POSITION', name: 'POSITION' },
          { id: 'RESIGNED DATE', name: 'RESIGNED DATE' },
        ],
        selectedDynamicColumns: [],
      }
    },
  
    created () {
      this.loading = true
        
      Promise.all([
        this.$api.payrollReports().reportYears(),
        this.$api.hrisCompanies().list(),
      ])
        .then(([years, company]) => {
          this.years = years.data
          this.companies = _.orderBy(company.data, ['name'], ['asc'])

          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.loading = false
        })
    },

    methods: {
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollReports().yearlySummaryListing(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            }).then(res => {
              let blob = new Blob([res.data], { type: res.data.type })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.setAttribute('download', 'Yearly Summary Listing ' + this.year + ' [' + this.$moment().format('YYYY-MM-DD h.mma') + '].xlsx')
              link.click()

              this.progressing = false
              this.progressbar = 0

              this.$snack({ message: 'Report downloaded successfully' })
            }).catch(() => {
              this.progressing = false

              this.$snack({ color: 'error', message: 'Error! Please contact support' })
            })
          })
      },

      prepareFormData () {
        return {
          year: this.year,
          categories: this.categoryColumns,
          company: this.company.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.company,
          dynamicColumns: this.selectedDynamicColumns,
        }
      },

    },
  }
</script>
